exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divBox[data-v-ca17cb04]{padding:20px}.box-card .clearfix .selWidth[data-v-ca17cb04]{width:200px}.box-card .clearfix .search-actions[data-v-ca17cb04]{margin-top:10px;display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px}.order-no .order-sub-no[data-v-ca17cb04]{color:#999;font-size:12px;margin-top:2px}.order-amount[data-v-ca17cb04]{color:#f56c6c;font-weight:bold}.pagination-container[data-v-ca17cb04]{margin-top:20px;text-align:right}.mr10[data-v-ca17cb04]{margin-right:10px}", ""]);

// exports
